<template>
	<section>
        <div>
            <div class="row">
                <div class="col-12 col-md-6 ">
	                <div class="h4">Program completion</div>
	                <p><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin id nisl in justo convallis tristique non at lectus. In vestibulum, purus quis porta ultrices.</small></p>
                    <test-chart :height="250" />
                </div><!--col-->
                <div class="col-12 col-md-6 ">
	                <div class="h4">Program completion</div>
	                <p><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin id nisl in justo convallis tristique non at lectus. In vestibulum, purus quis porta ultrices.</small></p>
                    <completion-pie-chart :height="250" />
                </div><!--col-->
            </div><!--row-->
            <hr class="mt-5 mb-5" />
            <div class="row">
	            <div class="col-12 col-md-6">
               		<div class="h4">Notifications</div>
			   		<p><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin id nisl in justo convallis tristique non at lectus. In vestibulum, purus quis porta ultrices.</small></p>
			   		
			   		<div class="white-content mt-3 mb-3">
				        <div class="notifications border" data-simplebar="">
					        <ul>
						        <li>
						        	<a href="#">
								        <span class="thumb-container" style="background-image: url(&quot;http://dev.sozpic.com/faberin/images/demo/cat1.jpg&quot;);"></span>
								        <p>3 HHAs are celebrating their Birthday today</p>
							        </a>
							    </li>
						        <li>
						        	<a href="#">
								        <span class="thumb-container" style="background-image: url(&quot;http://dev.sozpic.com/faberin/images/demo/cat2.jpg&quot;);"></span>
								        <p>You have 5 updates</p>
							        </a>
							    </li>
						        <li>
						        	<a href="#">
								        <span class="thumb-container" style="background-image: url(&quot;http://dev.sozpic.com/faberin/images/demo/cat3.jpg&quot;);"></span>
								        <p>you have 2 messages</p>
							        </a>
							    </li>
						        <li>
						        	<a href="#">
								        <span class="thumb-container" style="background-image: url(&quot;http://dev.sozpic.com/faberin/images/demo/cat4.jpg&quot;);"></span>
								        <p>3 HHAs are celebrating their Birthday today</p>
							        </a>
							    </li>
						        <li>
						        	<a href="#">
								        <span class="thumb-container" style="background-image: url(&quot;http://dev.sozpic.com/faberin/images/demo/cat5.jpg&quot;);"></span>
								        <p>3 HHAs are celebrating their Birthday today</p>
							        </a>
							    </li>
						    </ul>
						</div>
			   		</div>
	            </div><!--col-->
	            <div class="col-12 col-md-6">
               		<div class="h4">Active programs</div>
			   		<p><small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin id nisl in justo convallis tristique non at lectus. In vestibulum, purus quis porta ultrices.</small></p>
			   		<div class="table-responsive">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th class="green-content"></th>
									<th class="green-content">Course id</th>
									<th class="green-content">Course name</th>
									<th class="green-content">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in courses" >
									<td  class="thumb-container pb-100" :style="{ 'background-image' : 'url('+item.image+')' }"></td>
									<td>{{item.id}}</td>
									<td>{{item.name}}</td>
									<td>
										<!-- <router-link tag="a" :to="{ name : 'organization.courses.detail', params : { id : item.id } }" class="d-flex justify-content-center align-items-center"><strong class="green">View</strong></router-link> -->
									</td>
								</tr>
							</tbody>
						</table>
					</div>
	            </div><!--col-->
            </div><!--row-->
        </div>
    </section>
</template>

<script>
import TestChart from './../charts/TestChart.js';
import CompletionPieChart from './../charts/CompletionPieChart.js';

export default {

    components : {
        TestChart, CompletionPieChart
    },

    data() {
        return {
	        courses : []
           }
    },
	created : function(){
		this.getCourses();
	},
	mounted : function(){},
    methods: {
	    displayNotification: function(){
			this.$snotify.success('Holi', {
				timeout: 2000,
				showProgressBar: true,
				closeOnClick: false,
				pauseOnHover: true
			});
	    },
		getCourses : function(){
			var params = {
				filters : {
					page : this.current_page
				}
			}
			
			this.$store.dispatch('getCourses', params).then((res) => {
				this.courses = res.data.data;

			}).catch((error) => {
				console.log(error);
			});
		}
    }
};


</script>
<style lang="css">

.tags .vue-tags-input{
	max-width: none !important;
	margin-bottom: 30px;
}
.tags .vue-tags-input .input{
	padding: 10px;
}
.tags .tag.valid {
  background-color: #48a5a9;
}
</style>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationComponent.vue